module.exports = __webpack_public_path__ + "img/itSmer.28a5cfb7.svg";